import React from 'react'
import styled from 'styled-components'
import { withI18n } from 'react-i18next'
// @ts-ignore
import { CWBModal } from 'cwb-react'

const Modal = ({ className, title, message, onConfirm, onCancel, buttons, children, t }: any) => (
    <StyledModal
        className={`${className} cwb-modal`}
        title={title}
        body={message}
        hideModal={onCancel}
        isOpen={true}
        buttons={buttons || [
          <StyledButton key="cancel" className="cwb-btn-modal cwb-btn-primary" onClick={onCancel}>{t('Cancel')}</StyledButton>,
          <StyledButton key="ok" className="cwb-btn-modal cwb-btn-action" onClick={onConfirm}>{t('Ok')}</StyledButton>
        ]}
    >
      {children}
    </StyledModal>
)

const StyledModal = styled(CWBModal)`
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  
  &.create-role-modal {
    max-width: 450px;
    
    .modal-buttons{
      justify-content: space-around !important;
    }
  }
  
  .modal-dropdown{
    min-width: 200px;
    max-width: 200px;
    .cwb-dropdown__menu{
      .cwb-dropdown__option{
        min-width: 185px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;       
      }
    }
  }

  .modal-content {
    width: 100%;
  }

  .modal-body {
    border-bottom: 1px solid #E1E4E8;
    margin-bottom: 32px;
    padding-bottom: 16px;
  }

  .modal-buttons {
    justify-content: space-between !important;
  }

  .close-modal {
    right: 20px;

    &:before {
      color: #8395A7;
      font-size: 16px;
    }
  }
  
  .cwb-dropdown-wrapper {    
    .cwb-dropdown__menu-list{
      text-align: left;
    }
  }
`

const StyledButton = styled.button`
  min-width: 80px;
  
  &:first-child{
    margin-right: 16px;
  }
`

export default withI18n()(Modal);
